<template>
  <div class="manage-match-list">
    <div class="invite-list" v-if="inviteList.length > 0">
      <div class="item" v-for="item in inviteList" :key="item.id">
        <div class="name overflow-text">{{ item.chineseName }}</div>
        <div class="but" @click="accepted(item.chineseName,item.id,item.managerId)">接受邀请</div>
      </div>
    </div>
    <div style="height: 3px;"></div>
    <div class="match-list" v-if="list.length > 0">
      <div class="match" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
        <div class="row">
          <div style="display: flex">
            <van-image style="border-radius: 4px; width: 50px; height: 50px; overflow: hidden"
                       :src="imageView(item.icon, 100, 100)"></van-image>
            <div>
              <div class="info">{{ item.chineseName }}</div>
              <div class="account-name">{{ item.accountName }}</div>
            </div>
          </div>
          <img src="../../assets/grey-right.png" style="width: 13px; height: 13px;">
        </div>
        <div style="height: 18px; box-sizing: border-box; border-bottom: 1px #F6F6F8 solid;"></div>
      </div>
    </div>
    <van-empty description="暂无数据" v-else />
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Empty, Dialog } from 'vant'
Vue.use(VanImage).use(Empty).use(Dialog)
import {
  getBMMatchUnionListByUser,
  getUserCrmInviteList,
  acceptCrmInvite
} from "@/api/match";
import { QNImageUtil } from '@/utils'

export default {
  data() {
    return {
      list: [],
      merchantId: '',
      inviteList: []
    }
  },
  mounted() {
    this.getBMMatchUnionListByUser()
    this.getUserCrmInviteList()
  },
  methods: {
    goDetail(item) {
      this.$router.replace({ path: `/match-manage/match-detail/` + item.id })
    },
    getUserCrmInviteList() {
      getUserCrmInviteList().then(res => {
        if (res) {
          const { data } = res
          const list = data.list.map(item => {
            return {
              chineseName:item.unionMatchName || item.name,
              id: item.id,
              managerId: item.managerId
            }
          }) || []
          this.inviteList = list
        }
      })
    },
    accepted(name,id,managerId) {
      Dialog.confirm({
        title: '系统提示',
        message: `确认需要管理[${name}]`,
      }).then(() => {
        acceptCrmInvite({ id,managerId }).then(() => {
          this.getBMMatchUnionListByUser()
          this.getUserCrmInviteList()
        })
      });
    },
    getBMMatchUnionListByUser() {
      const params = {
        merchantId: this.merchantId,
        pageSize: 999,
        pageNum: 1
      }
      getBMMatchUnionListByUser(params).then(res => {
        const data = res.data
        this.list = data.list
      })
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    }
  }
}
</script>

<style lang="scss" scoped>
.manage-match-list {
  min-height: 100vh;
  background-color: #F6F6F8;

  .invite-list {
    .item {
      background-color: #F6F6F8;
      padding: 8px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .name {
        font-size: 14px;
        font-weight: 500;
        padding-right: 12px;
      }

      .but {
        min-width: 88px;
        font-size: 12px;
        color: #1565FC;
        border-radius: 12px;
        border: 1px solid #1565FC;
        text-align: center;
        box-sizing: border-box;
        padding: 4px 0;
      }
    }
  }

  .match-list {
    background-color: #FFFFFF;

    .match {
      padding: 18px 12px 0 12px;

      .row {
        display: flex;
        align-items: center;
        .info {
          width: calc(100vw - 140px);
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0 26px 0 8px;
          font-size: 15px;
          color: #191919;
          font-weight: 500;
        }
        .account-name {
          width: calc(100vw - 140px);
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0 26px 0 8px;
          font-size: 13px;
          color: #333333;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
